export default __webpack_public_path__ + "static/media/DNo.17-5.51b54d0d.jpg";